import ChatGroup, { ChatGroupId } from '@/chat/models/ChatGroup';
import WorkshopTeam, { WorkshopTeamId } from '@/general/models/WorkshopTeam';
import CommonFilterType from '../constants/CommonFilterType';
import { present } from '../utils/typescript';
import Brand, { BrandId } from './Brand';
import Outlet, { OutletId } from './Outlet';
import Tag, { TagId } from './Tag';
import User, { UserId } from './User';

export default class CommonFilters {
  constructor(
    readonly outlets: Array<Outlet>,
    readonly activeOutletIds: Array<OutletId>,
    readonly brands: Array<Brand>,
    readonly activeBrandId: BrandId | null,
    readonly teams: Array<WorkshopTeam>,
    readonly activeTeamId: WorkshopTeamId | null,
    readonly users: Array<User>,
    readonly activeUserIds: Array<UserId>,
    readonly groups: Array<ChatGroup>,
    readonly activeGroupIds: Array<ChatGroupId>,
    readonly dossierTags: Array<Tag>,
    readonly activeDossierTagIds: Array<TagId>,
    readonly activeTypes: Set<CommonFilterType>,
  ) {}

  getFirstActiveOutlet(): Outlet {
    return present(this.outlets.find(o => this.activeOutletIds[0] === o.id), 'no outlets selected');
  }

  getActiveOutlets(): Array<Outlet> {
    return this.outlets.filter(o => this.activeOutletIds.includes(o.id));
  }

  getActiveBrand(): Brand | undefined {
    if (this.activeBrandId !== null) return this.brands.find(b => this.activeBrandId === b.id);
  }

  getActiveTeam(): WorkshopTeam | undefined {
    if (this.activeTeamId !== null) return this.teams.find(t => this.activeTeamId === t.id);
  }

  getActiveUsers(): Array<User> {
    return this.users.filter(u => this.activeUserIds.includes(u.id));
  }

  getActiveGroups(): Array<ChatGroup> {
    return this.groups.filter(g => this.activeGroupIds.includes(g.id));
  }

  getActiveDossierTags(): Array<Tag> {
    return this.dossierTags.filter(t => t.id !== null && this.activeDossierTagIds.includes(t.id));
  }
}